// Shared "is this input node unconfigured?" check — drives both the per-node
// warning hint (BaseNode) and the pre-run guard (engine).

import { type Node, type Edge } from '@xyflow/react';

/** Returns a short reason if an input node still needs configuration, else null. */
export function unconfiguredReason(node: Node, edges: Edge[]): string | null {
  const data = (node.data ?? {}) as Record<string, unknown>;
  const hasIncoming = (handle: string) =>
    edges.some((e) => e.target === node.id && e.targetHandle === handle);

  switch (node.type) {
    case 'imageUpload':
      return data.image ? null : 'No image uploaded';
    case 'imageGallery':
      return data.imageUrl ? null : 'No image selected';
    case 'promptInput':
      // OK if it has text or receives text from upstream ({input}).
      return String(data.text ?? '').trim() || hasIncoming('input') ? null : 'Empty prompt';
    default:
      return null;
  }
}
